// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"UserAddForm_formWrapper__-Fztf","headerWrapper":"UserAddForm_headerWrapper__2xT83"};